import { createContext, ReactNode, useContext } from "react";
import { useRealViewportHeight } from "../hooks/useRealViewportHeight";

type ViewportContextValue = {
  vh: number;
};

const ViewportContext = createContext<ViewportContextValue>({ vh: 0 });

export function ViewportProvider({ children }: { children: ReactNode }) {
  const vh = useRealViewportHeight();

  return <ViewportContext.Provider value={{ vh }}>{children}</ViewportContext.Provider>;
}

export function useViewport() {
  return useContext(ViewportContext);
}
